import { render, staticRenderFns } from "./activeForm.vue?vue&type=template&id=1cc545de&scoped=true&"
import script from "./activeForm.vue?vue&type=script&lang=js&"
export * from "./activeForm.vue?vue&type=script&lang=js&"
import style0 from "./activeForm.vue?vue&type=style&index=0&id=1cc545de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc545de",
  null
  
)

export default component.exports